var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow3Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23499 4.6425L5.45249 1.86C5.39999 1.8075 5.33249 1.7625 5.25749 1.7325C5.24999 1.7325 5.24249 1.7325 5.23499 1.725C5.17499 1.7025 5.11499 1.6875 5.04749 1.6875C4.89749 1.6875 4.75499 1.7475 4.64999 1.8525L1.85249 4.6425C1.63499 4.86 1.63499 5.22 1.85249 5.4375C2.06999 5.655 2.42999 5.655 2.64749 5.4375L4.48499 3.6V15.75C4.48499 16.0575 4.73999 16.3125 5.04749 16.3125C5.35499 16.3125 5.60999 16.0575 5.60999 15.75V3.6075L7.43999 5.4375C7.55249 5.55 7.69499 5.6025 7.83749 5.6025C7.97999 5.6025 8.12249 5.55 8.23499 5.4375C8.45249 5.22 8.45249 4.8675 8.23499 4.6425Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1475 12.5625C15.93 12.345 15.57 12.345 15.3525 12.5625L13.515 14.4V2.25C13.515 1.9425 13.26 1.6875 12.9525 1.6875C12.645 1.6875 12.39 1.9425 12.39 2.25V14.3925L10.56 12.5625C10.3425 12.345 9.98249 12.345 9.76499 12.5625C9.54749 12.78 9.54749 13.14 9.76499 13.3575L12.5475 16.14C12.6 16.1925 12.6675 16.2375 12.7425 16.2675C12.75 16.2675 12.7575 16.2675 12.765 16.275C12.825 16.2975 12.8925 16.3125 12.96 16.3125C13.11 16.3125 13.2525 16.2525 13.3575 16.1475L16.1475 13.3575C16.365 13.1325 16.365 12.78 16.1475 12.5625Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3Black);
export default __webpack_public_path__ + "static/media/arrow-3_black.08872424122caf98cb3a12eee16f72d6.svg";
export { ForwardRef as ReactComponent };